/**
 * @generated SignedSource<<5749614ce17129197308d2d4f501fb0d>>
 * @relayHash 21d0b47fcf064339c2da2e1cca62fba5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b24797ba7d3495ef094dc98fcd0b961ddebdef927e9cb13d321de672491ed872

import type { ConcreteRequest, Query } from 'relay-runtime';
export type workSuggestionsJiraBoardFetchPullRequestWorkSuggestionsForIssueQuery$variables = {
  cloudId: string;
  issueId: string;
};
export type workSuggestionsJiraBoardFetchPullRequestWorkSuggestionsForIssueQuery$data = {
  readonly workSuggestions: {
    readonly suggestionsByIssues: {
      readonly recentPullRequests: {
        readonly mergeableSuggestions: ReadonlyArray<{
          readonly __typename: "WorkSuggestionsPRMergeableTask";
          readonly id: string;
          readonly isMergeActionEnabled: boolean | null | undefined;
          readonly url: string;
        }> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type workSuggestionsJiraBoardFetchPullRequestWorkSuggestionsForIssueQuery = {
  response: workSuggestionsJiraBoardFetchPullRequestWorkSuggestionsForIssueQuery$data;
  variables: workSuggestionsJiraBoardFetchPullRequestWorkSuggestionsForIssueQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueId"
  }
],
v1 = [
  {
    "concreteType": "WorkSuggestions",
    "kind": "LinkedField",
    "name": "workSuggestions",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "items": [
              {
                "kind": "Variable",
                "name": "issueIds.0",
                "variableName": "issueId"
              }
            ],
            "kind": "ListValue",
            "name": "issueIds"
          }
        ],
        "concreteType": "WorkSuggestionsByIssuesResponse",
        "kind": "LinkedField",
        "name": "suggestionsByIssues",
        "plural": false,
        "selections": [
          {
            "concreteType": "WorkSuggestionsPullRequestSuggestionsResponse",
            "kind": "LinkedField",
            "name": "recentPullRequests",
            "plural": false,
            "selections": [
              {
                "concreteType": "WorkSuggestionsPRMergeableTask",
                "kind": "LinkedField",
                "name": "mergeableSuggestions",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "id"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isMergeActionEnabled"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "url"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "workSuggestionsJiraBoardFetchPullRequestWorkSuggestionsForIssueQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "workSuggestionsJiraBoardFetchPullRequestWorkSuggestionsForIssueQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "b24797ba7d3495ef094dc98fcd0b961ddebdef927e9cb13d321de672491ed872",
    "metadata": {},
    "name": "workSuggestionsJiraBoardFetchPullRequestWorkSuggestionsForIssueQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "23e6f37e25e00b8564aa25ef11d3ee85";

export default node;
